var styles = {
  "Header": "Online-Store-UI-Header_1al6o",
  "Content": "Online-Store-UI-Header__Content_53opg",
  "hasBackArrow": "Online-Store-UI-Header--hasBackArrow_14p8w",
  "hasRightCloseAction": "Online-Store-UI-Header--hasRightCloseAction_1z47r",
  "hasRollupMenu": "Online-Store-UI-Header--hasRollupMenu_159y7",
  "PrefixTitleWrapper": "Online-Store-UI-Header__PrefixTitleWrapper_1gaue",
  "Prefix": "Online-Store-UI-Header__Prefix_1bqcj",
  "Title": "Online-Store-UI-Header__Title_pcigr",
  "TitleHeading": "Online-Store-UI-Header__TitleHeading_os7zq",
  "strong": "Online-Store-UI-Header--strong_1mtqo",
  "Subtitle": "Online-Store-UI-Header__Subtitle_fp8jm",
  "CloseAction": "Online-Store-UI-Header__CloseAction_1eepm",
  "RollupMenuWrapper": "Online-Store-UI-Header__RollupMenuWrapper_96ae0"
};

export { styles as default };
